/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// redux utils
import { createSlice } from '@reduxjs/toolkit';
// thunks
import { fetchMigrationStatus, updateMigrationStatus, fetchSitesWithV2Products } from 'state/thunks/migration';
import { COMMENTING_2_0_ACTIVATION_READY, DATA_MIGRATION_READY } from 'utils/consts/migration';
import { log } from '@insticator/insticator-ui'; // iui-material

/* ========== ~~~~~~~~~~ MIGRATION STATUS V2 SLICE : REDUCER ~~~~~~~~~~ ========== */
export const migrationStatusSlice = createSlice({
    name: 'migrationStatus',
    initialState: {
      migrationStatus: COMMENTING_2_0_ACTIVATION_READY,
      isMigrationUpdating: false,
      requestFailed: false,
      migration: {
        migrationStatus: null,
        processedThreads: 0,
        updatedAt: null,
        canStartMigration: false
      },
      sitesWithProductsV2: []
    },
    reducers: {
        setTempDisplayConfigEmojis: (state, action) => {
            state.tempDisplayConfig.emojis = action.payload
        },
        setMigrationStatus: (state, action) => {
          state.migrationStatus = action.payload
        },
        setSitesWithProductsV2: (state, action) => {
          state.sitesWithProductsV2 = action.payload
        },
        addSiteWithProductsV2: (state, action) => {
          const siteUUID = action.payload
          if(!siteUUID || typeof siteUUID != 'string') return
          if(state.sitesWithProductsV2.includes(siteUUID)) return
          state.sitesWithProductsV2 = [...state.sitesWithProductsV2, siteUUID]
        }
    },
    extraReducers: builder => {
      builder

        // fetch migration status
        .addCase(fetchMigrationStatus.pending, (state, action) => {
          state.requestFailed = false
        })
        .addCase(fetchMigrationStatus.fulfilled, (state, action) => {
            log('fetch migration status: ', action.payload)
            state.migrationStatus = action.payload?.migrationStatus || state.migrationStatus
            state.migration = action.payload 
        })
        .addCase(fetchMigrationStatus.rejected, (state, action) => {
          state.requestFailed = true
        })
        
        // update display config config
        .addCase(updateMigrationStatus.pending, (state, action) => {
            state.isMigrationUpdating = true
            state.requestFailed = false
        })
        .addCase(updateMigrationStatus.fulfilled, (state, action) => {
            log('update migration status:', action.payload)
            // if successful set the new migration status else use the current one
            state.migrationStatus = action.payload?.migrationStatus || state.migrationStatus
            if(action.payload) state.migration = action.payload
            state.isMigrationUpdating = false
        })
        .addCase(updateMigrationStatus.rejected, (state, action) => {
            state.isMigrationUpdating = false
            state.requestFailed = true
        })    

        
        // fetch sites with 2.0 Products
        .addCase(fetchSitesWithV2Products.pending, (state, action) => {

        })
        .addCase(fetchSitesWithV2Products.fulfilled, (state, action) => {
            state.sitesWithProductsV2 = action.payload || []
        })
        .addCase(fetchSitesWithV2Products.rejected, (state, action) => {
        })
    }
});

export const { setMigrationStatus, setSitesWithProductsV2, addSiteWithProductsV2 } = migrationStatusSlice.actions
export default migrationStatusSlice.reducer;
